const products = [
  {
    id: 7491521020038,
    title: 'SHUT THE F*CK UP HOODIE',
    handle: 'shut-the-f-ck-up-hoodie',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/hoodie-1.webp?v=1762863173',
    variants: [
      { id: 42559350276230, isOffer: false, title: 'M', price: '2000.00', compare_at_price: null },
      { id: 42559350308998, isOffer: false, title: 'L', price: '2000.00', compare_at_price: null },
      { id: 42559350243462, isOffer: false, title: 'S', price: '2000.00', compare_at_price: null },
      { id: 42559350341766, isOffer: false, title: 'XL', price: '2000.00', compare_at_price: null },
      { id: 42559454675078, isOffer: false, title: '2XL', price: '2000.00', compare_at_price: null },
    ],
  },
  {
    id: 7484768059526,
    title: 'LOVE: Moisturising Lip Tint Oil Freebie',
    handle: 'love-moisturising-lip-tint-oil-freebie',
    image_url:
      'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/Love_bc535591-40e5-4893-99ab-77724887c803.webp?v=1763721703',
    variants: [{ id: 42539565613190, isOffer: false, title: '10g', price: '0.00', compare_at_price: '500.00' }],
  },
  {
    id: 7484767928454,
    title: 'FRESH AF: Purifying Foaming Cleanser Freebie',
    handle: 'fresh-af-purifying-foaming-cleanser-freebie',
    image_url:
      'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/fresh_ed01ee31-2b6c-4b99-b202-2fbf62617a17.webp?v=1763721731',
    variants: [{ id: 42539560730758, isOffer: false, title: '100g', price: '0.00', compare_at_price: '500.00' }],
  },
  {
    id: 7484767764614,
    title: 'GLOW: Boosting Hydrating Moisturiser Freebie',
    handle: 'glow-boosting-hydrating-moisturiser-freebie',
    image_url:
      'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/glow_1c5ea526-1a58-44cd-8c3c-8f7ee21fae9c.webp?v=1763721776',
    variants: [{ id: 42539558895750, isOffer: false, title: '50g', price: '0.00', compare_at_price: '800.00' }],
  },
  {
    id: 7471417655430,
    title: 'The Screen Shield Kit',
    handle: 'essential-kit-pack-of-3-copy',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/1X1_0003s_0002_R397.jpg?v=1762774742',
    variants: [{ id: 42533078794374, isOffer: true, title: '52.5g', price: '1350.00', compare_at_price: null }],
  },
  {
    id: 7471476506758,
    title: 'The Self-Care Starter Kit',
    handle: 'the-on-the-go-glow-kit-copy',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/1X1_0001s_0000_Levels1.jpg?v=1762774731',
    variants: [{ id: 42533069062278, isOffer: true, title: '195g', price: '1900.00', compare_at_price: null }],
  },
  {
    id: 7316941963398,
    title: 'FIRST CRUSH: Dual Core Blush Stick',
    handle: 'firstcrush-dual-core-blush-stick',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/crush.webp?v=1763716891',
    variants: [
      { id: 42477961478278, isOffer: true, title: 'Sorbet', price: '800.00', compare_at_price: null },
      { id: 42477961511046, isOffer: true, title: 'Jammy', price: '800.00', compare_at_price: null },
      { id: 42477961543814, isOffer: true, title: 'Bellini', price: '800.00', compare_at_price: null },
    ],
  },
  {
    id: 7436081627270,
    title: 'SMOOTH OPERATOR: Satin serum',
    handle: 'smooth-operator-satin-serum-for-smoothening-and-frizz-control',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/smooth_operator.webp?v=1763716839',
    variants: [
      { id: 42454809477254, isOffer: false, title: '10ml', price: '150.00', compare_at_price: null },
      { id: 42454809444486, isOffer: true, title: '50ml', price: '530.00', compare_at_price: null },
    ],
  },
  {
    id: 7450150043782,
    title: 'The You Do You tote',
    handle: 'the-you-do-you-tote',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/1050X1005_0001s_0001_Group1.jpg?v=1762774753',
    variants: [{ id: 42395247902854, isOffer: false, title: 'Default Title', price: '300.00', compare_at_price: null }],
  },
  {
    id: 7450149585030,
    title: 'The Dammmm cap',
    handle: 'the-dammmm-cap',
    image_url:
      'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/1050X1005_0000s_0000_Sammm_Day_20462-0448.jpg?v=1762774762',
    variants: [{ id: 42441472934022, isOffer: false, title: 'Default Title', price: '750.00', compare_at_price: null }],
  },
  {
    id: 7417349111942,
    title: 'Essential Kit (Pack of 3)',
    handle: 'essential-kit-pack-of-3',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/essential-kit-1.webp?v=1762861581',
    variants: [{ id: 42533101142150, isOffer: true, title: '160.0g', price: '1800.00', compare_at_price: null }],
  },
  {
    id: 7393898594438,
    title: 'Essential Kit With Crush',
    handle: 'essential-kit',
    image_url:
      'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/bundle-image2_8c2ec3a9-da3a-4b3c-86a6-95351f7fbcab.jpg?v=1750673315',
    variants: [{ id: 42533100683398, isOffer: false, title: '167.5g', price: '2600.00', compare_at_price: null }],
  },
  {
    id: 7431583367302,
    title: 'SUNNYSIDE : Sun Protection Gel Cream',
    handle: 'sunnyside-sun-protection-gel-cream-with-spf-50-pa',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/sunnyside.webp?v=1763650843',
    variants: [
      { id: 42483537444998, isOffer: false, title: '10g', price: '150.00', compare_at_price: null },
      { id: 42454838378630, isOffer: true, title: '45g', price: '600.00', compare_at_price: null },
    ],
  },
  {
    id: 7316942422150,
    title: 'DEW IT ALL: 3-in-1 Primer & Sunstick',
    handle: 'glowshield-3-in-1-primer-sunstick-with-spf-50',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/dew_it_all.webp?v=1763716930',
    variants: [{ id: 42487304749190, isOffer: true, title: '7.5g', price: '750.00', compare_at_price: null }],
  },
  {
    id: 7296600506502,
    title: 'LOVE: Moisturising Lip Tint Oil',
    handle: 'moisturising-lip-tint-oil',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/Love.webp?v=1763717064',
    variants: [{ id: 42483265601670, isOffer: true, title: '10g', price: '500.00', compare_at_price: null }],
  },
  {
    id: 7296589496454,
    title: 'FRESH AF: Purifying Foaming Cleanser',
    handle: 'fresh-af-purifying-foaming-cleanser',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/fresh.webp?v=1763716982',
    variants: [
      { id: 42947480584326, isOffer: false, title: '50g', price: '300.00', compare_at_price: null },
      { id: 42487300784262, isOffer: true, title: '100g', price: '500.00', compare_at_price: null },
    ],
  },
  {
    id: 7245586432134,
    title: 'GLOW: Boosting Hydrating Moisturiser',
    handle: 'glow-boosting-hydrating-moisturiser',
    image_url: 'https://cdn.shopify.com/s/files/1/0580/9809/0118/files/glow.webp?v=1763717016',
    variants: [
      { id: 42947480649862, isOffer: false, title: '30g', price: '500.00', compare_at_price: null },
      { id: 42487303045254, isOffer: true, title: '50g', price: '800.00', compare_at_price: null },
    ],
  },
];
